import { authorize, getRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function getLightningDevicesAPI() {
  const url = `${AWS_API_URL}/lighting/devices`;

  return getRequest(url, await authorize());
}
